import { HYDRATE, HydrateAction } from "@/redux/reducers/hydration";

export enum ToastType {
  Info,
  Warning,
  Error,
}

export type Toast = {
  id: string;
  message: React.ReactNode;
  type: ToastType;
};

type ToastsState = {
  toasts: Toast[];
};

export const initialState: ToastsState = {
  toasts: [],
};

export const TOASTS_NOTIFY = "toasts/notify";
export const TOASTS_DISMISS = "toasts/dismiss";

type ToastReducerActionNotify = {
  type: typeof TOASTS_NOTIFY;
  value: Toast;
};

type ToastReducerActionDismiss = {
  type: typeof TOASTS_DISMISS;
  value: string;
};

export type ToastsActions =
  | ToastReducerActionNotify
  | ToastReducerActionDismiss
  | HydrateAction;

const toastReducer = (
  state = initialState,
  action: ToastsActions,
): ToastsState => {
  switch (action.type) {
    case HYDRATE:
      /**
       * Ignore any hydration events after initial page load to preserve any
       * subsequent changes that have been made on the client.
       */
      return state;
    case TOASTS_NOTIFY: {
      return { ...state, toasts: [...state.toasts, action.value] };
    }
    case TOASTS_DISMISS: {
      return {
        ...state,
        toasts: state.toasts.filter((item) => item.id !== action.value),
      };
    }
    default:
      return state;
  }
};

export default toastReducer;
